import { Component, OnInit } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { TiimeOverlayRef } from 'tiime-material';

import { AppStoreState } from '@interfaces/app-store-state';
import { Company } from '@models/company';
import { companySelector } from '@modules/company/company-core/store/company/company-selector';
import { NavigationService } from '@modules/core/navigation/navigation.service';
import { ReloadService } from '@services/reload.service';

import { UploadFile } from '../upload-file';
import { UploadDocumentService } from './upload-document.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-upload-document-overlay',
  templateUrl: './upload-document-overlay.component.html',
  styleUrls: ['./upload-document-overlay.component.scss']
})
export class UploadDocumentOverlayComponent implements OnInit {
  private companyId: number;
  private subscription = new Subscription();

  get currentFiles(): UploadFile[] {
    return this.uploadDocumentService.filesInQueue;
  }
  get hasPendingUpload(): boolean {
    return this.uploadDocumentService.hasPendingUpload;
  }

  constructor(
    private uploadDocumentService: UploadDocumentService,
    private overlayRef: TiimeOverlayRef,
    private store: Store<AppStoreState>,
    private reloadService: ReloadService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.observeUploadQueue();
    this.initCompany();
  }

  closeOverlay(): void {
    this.overlayRef.close();
  }

  navigateOrRefreshList(): void {
    this.subscription.add(
      combineLatest([
        this.navigationService.isCompanyDocumentsRouteActive(),
        this.navigationService.isCompanyExternalInvoicesRouteActive()
      ])
        .pipe(
          tap(([companyDocumentsRouteActive, companyExternalInvoicesRouteActive]) => {
            if (companyDocumentsRouteActive || companyExternalInvoicesRouteActive) {
              this.reloadService.reloadCurrentView(true);
            } else {
              this.navigationService.navigateToCompanyDocuments(this.companyId);
            }
          })
        )
        .subscribe()
    );

    this.overlayRef.close();
  }

  private initCompany(): void {
    this.subscription.add(
      this.store
        .pipe(
          select(companySelector),
          take(1),
          tap((company: Company) => (this.companyId = company.id))
        )
        .subscribe()
    );
  }

  private observeUploadQueue(): void {
    this.subscription.add(this.uploadDocumentService.observeUploadQueue().subscribe());
  }
}
